export const QstReferences = {
  RefSection1Qst01: "01sec01q",
  RefSection1Qst02: "01sec02q",
  RefSection1Qst03: "01sec03q",
  RefSection1Qst04: "01sec04q",
  RefSection1Qst05: "01sec05q",
  RefSection2Qst01: "02sec01q",
  RefSection2Qst02: "02sec02q",
  RefSection2Qst03: "02sec03q",
  RefSection3Qst01: "03sec01q",
  RefSection3Qst02: "03sec02q",
  RefSection3Qst03: "03sec03q",
  RefSection3Qst04: "03sec04q",
  RefSection3Qst05: "03sec05q",
  RefSection4Qst01: "04sec01q",
  RefSection4Qst02: "04sec02q",
  RefSection4Qst03: "04sec03q",
  RefSection4Qst04: "04sec04q",
  RefSection4Qst05: "04sec05q",
  RefSection5Qst01: "05sec01q",
  RefSection5Qst02: "05sec02q",
  RefSection5Qst03: "05sec03q",
  RefSection5Qst04: "05sec04q",
  RefSection6Qst01: "06sec01q",
  RefSection6Qst02: "06sec02q",
  RefSection6Qst03: "06sec03q",
  RefSection6Qst04: "06sec04q",
  RefSection6Qst05: "06sec05q",
}
